import { Route, Switch } from 'react-router-dom';
import { INVESTIGATION_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import Login from '../components/Login/Login';
import SupportLogin from '../components/SupportLogin/SupportLogin';
import Forbidden from './pages/Forbidden/Forbidden';
import Logout from '../components/Logout/Logout';
import NotFound from './pages/NotFound/NotFound';
import { LogicalRoute } from './helpers/LogicalRoute';
import { useSuportLoginDisabled } from '../components/SupportLogin/supportLoginHooks';
import { NhiOnPermRouting } from '../modules/nhi/onPrem/routings/NhiOnPremRouting';
import { PrivilegeAccountsRouting } from '../modules/privilegeAccounts/routing/PrivilegeAccountsRouting';
import { DashboardRouting } from './pagesRouting/DashboardRouting';
import { IspmRouting } from './pagesRouting/IspmRouting';
import { PolicyRouting } from './pagesRouting/PolicyRouting';
import { CloudNHIRouting } from '../components/CloudNHI/routing/CloudNHIRouting';
import { ApplicationsDiscoveryRouting } from './pagesRouting/ApplicationDiscoveryRouting';
import { IspmCloudRouting } from './pagesRouting/IspmCloudRouting';
import { InvestigationRouting } from './pagesRouting/InvestigationRouting';
import { IncidentInvestigationRouting } from './pagesRouting/IncidentInvestigationRouting';
import { UsersRouting } from './pagesRouting/UserRouting';
import { LogsRouting } from './pagesRouting/LogsRouting';
import { SystemStatusRouting } from './pagesRouting/SystemStatusRouting';
import { SystemNotificationsRouting } from './pagesRouting/SystemNotificationsRouting';
import { SoftwareUpdatesRouting } from './pagesRouting/SoftwareUpdatesRouting';
import { SettingsRouting } from './pagesRouting/SettingsRouting';
import { ItdrOnPremRouting } from './pagesRouting/ItdrOnPremRouting';
import { ItdrCloudRouting } from './pagesRouting/ItdrCloudRouting';
import { AzureADResultRouting } from './pagesRouting/AzureADResultRouting';
import { AzureADSuccessRouting } from './pagesRouting/AzureADSuccessRouting';
import { OktaSuccessRouting } from './pagesRouting/OktaSuccessRouting';
import { InventoryRouting } from './pagesRouting/InventoryRouting';
import { AccessAnalysisCloudRouting, AccessAnalysisRouting } from '../modules/accessAnalysis/routes';
import { AuthenticationFirewallDashboardRouting } from './pagesRouting/AuthenticationFirewallDashboardRouting';
import { UniversalMFADashboardRouting } from './pagesRouting/UniversalMFADashboardRouting';
import { CloudAIAgentSecurityRouting } from '../modules/aiAgentSecurity/routes/CloudAIAgentSecurityRouting';
import { CloudAiProtectionRouting } from './pagesRouting/CloudAiProtectionRouting';
import { AIAssistantRouting } from './pagesRouting/AIAssistantRouting';

export default function SiteRoutings() {
    return (
        <Switch>
            <DashboardRouting exact path="/" />
            <Route path="/Login" component={Login} />
            <Route path="/Logout" component={Logout} />
            <LogicalRoute path="/sbmbenoagyogrhlg" component={SupportLogin} disabled={useSuportLoginDisabled()} />
            <IspmRouting path="/Ispm" />
            <IspmCloudRouting path="/IspmCloud" />
            <PrivilegeAccountsRouting path="/PrivilegedAccounts" />
            <PolicyRouting path="/Policy" />
            <AuthenticationFirewallDashboardRouting path="/AuthenticationFirewallDashboard" />
            <UniversalMFADashboardRouting path="/UniversalMFADashboard" />
            <NhiOnPermRouting path="/ServiceAccounts" />
            <CloudNHIRouting path="/CloudNHI" />
            <ApplicationsDiscoveryRouting path="/ApplicationsDiscovery" />
            <AccessAnalysisRouting path="/AccessAnalysis" />
            <AccessAnalysisCloudRouting path="/AccessAnalysisCloud" />
            <InvestigationRouting path={INVESTIGATION_ENTITY_TYPES.RESOURCE.urlPrefix + ':guid'} />
            <InvestigationRouting path={INVESTIGATION_ENTITY_TYPES.USER.urlPrefix + ':guid'} />
            <InvestigationRouting path={INVESTIGATION_ENTITY_TYPES.APPLICATION.urlPrefix + ':guid'} />
            <InvestigationRouting path={INVESTIGATION_ENTITY_TYPES.OKTA.urlPrefix + ':guid'} />
            <IncidentInvestigationRouting
                path={INVESTIGATION_ENTITY_TYPES.INCIDENT.urlPrefix + ':incidentType/:incidentID'}
            />
            <CloudAIAgentSecurityRouting path="/AIAgentSecurityCloud" />
            <CloudAiProtectionRouting path="/ai-access-control" />
            <AIAssistantRouting path="/AIAssistant" />
            <UsersRouting path="/UserManagement" />
            <LogsRouting path="/Logs" />
            <SystemStatusRouting path="/SystemStatus" />
            <SystemNotificationsRouting path="/SystemEvents" />
            <SoftwareUpdatesRouting path="/SoftwareUpdates" />
            <SettingsRouting path="/Settings" />
            <InventoryRouting path="/Inventory" />
            <ItdrOnPremRouting path="/Itdr" />
            <ItdrCloudRouting path="/ItdrCloud" />
            <AzureADResultRouting path="/AzureADResult" />
            <AzureADSuccessRouting path="/AzureADSuccess" />
            <OktaSuccessRouting path="/OktaSuccess" />
            <Route path="/Forbidden" component={Forbidden} />
            <Route path="*" component={NotFound} />
        </Switch>
    );
}
